import { render, staticRenderFns } from "./accessory-item.vue?vue&type=template&id=08d3a385&scoped=true&"
import script from "./accessory-item.vue?vue&type=script&lang=js&"
export * from "./accessory-item.vue?vue&type=script&lang=js&"
import style0 from "./accessory-item.vue?vue&type=style&index=0&id=08d3a385&lang=scss&scoped=true&"
import style1 from "./accessory-item.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d3a385",
  null
  
)

export default component.exports